// classnames - `cn` helper: clsx + tailwind-merge for conflict-free class lists.
//
// tailwind-merge has to be TAUGHT our scale, and the failure when it is not is
// silent and total.
//
// It resolves conflicts by sorting each class into a group. For `text-*` it
// decides between font-size and text-colour by testing the value against its
// own list of Tailwind's DEFAULT sizes - xs, sm, base, lg, and so on. Our
// scale is named micro / mini / data / prose / title / display, none of which
// are on that list, so every one of them was filed as a COLOUR. Then any
// `cn('text-mini …', 'text-ink-400')` looked to twMerge like two colours in
// conflict, and it kept the last: the size was deleted on its way to the DOM
// and the element fell back to `body` at 16px.
//
// This is why the report's tabs, sub-tabs and filter chips stayed large through
// four separate retunings of the scale - the source said `text-mini`, the
// browser never saw it. Elements written as a plain string className were
// untouched, because twMerge never ran on them, which is exactly why the bug
// looked arbitrary: two elements one line apart, one correct and one not.
//
// The same trap applies to every custom key in tailwind.config.ts. `rounded-
// chip` and `rounded-panel` are declared here for the same reason.

import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Must match `fontSize` in tailwind.config.ts, and TYPE in
      // components/report/Primitives.tsx.
      'font-size': [
        { text: ['micro', 'mini', 'data', 'prose', 'title', 'display', 'doc-h1', 'doc-h1-compact', 'doc-h2', 'doc-h3', 'doc-body'] },
      ],
      // Must match `borderRadius` in tailwind.config.ts.
      rounded: [{ rounded: ['chip', 'panel'] }],
    },
  },
});

/** cn - combine class names, dedup tailwind classes. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
